// common funtion that will handle input validations

import { enumUtil } from "./Enum"
import isNull from "./NullChecking"


const FormValidator = (data, type, name, length, lengths) => {
    // data will be input field value of modal 
    // type will be required or null check etc 
    // name will be used for returning msg
    // length if we are going to check lenght of filed then type will be lengthCheck


    if (data instanceof Array && type === enumUtil.enumValidationType.NullCheck) {
        //if any value of Array is a Object then it will retrun true otherwise false

        if (!isNull(data)) {
            let array = Object.values(data[0])
            let dummy_Array = []
            for (let i = 0; i < array.length; i++) {
                dummy_Array.push(array[i])
            }
            let result = !dummy_Array.every((VALUE) => !hasObject(VALUE))
            return result
        }
    }
    if (type === enumUtil.enumValidationType.Required) {
        if (isNull(data)) {
            return (
                <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                    <i className="bi bi-info-circle-fill fs-10"></i>
                    <p className="fs-9 text-white text">{capitalize(name)} Is Required!</p>
                </div>
            )
        } else {
            return ''
        }
    } else if (type === enumUtil.enumValidationType.Length) {
        if (!isNull(data)) {
            console.log('Length')
            if (data.length < length && data.length > 0) {
                return (
                    <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                        <i className="bi bi-info-circle-fill fs-10"></i>
                        <p className="fs-9 text-white text">{' '}
                            {capitalize(name)} length should be {length} !</p>
                    </div>
                )
            } else {
                return ''
            }
        }
        ///////////////////////// For Normal Validation Code END/////////////////////
    } else if (type === enumUtil.enumValidationType.Lengths) {
        if (!isNull(data)) {
            if (data.length > 0) {
                if (data.length === length || data.length === lengths) { }
                else {
                    console.log('Length')
                    return (
                        <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                            <i className="bi bi-info-circle-fill fs-10"></i>
                            <p className="fs-9 text-white text">   {' '}
                                {capitalize(name)} length should be {length} or {lengths}!</p>
                        </div>
                    )
                }

            }
        }
        ///////////////////////// For Normal Validation Code END/////////////////////
    } else if (type === enumUtil.enumValidationType.Password) {
        var regularExpression = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,}$/
        if (!regularExpression.test(data) && data.length > 0) {
            return (
                <div className="text-error" style={{ display: "block" }}>
                    {' '}
                    {"Your password must be at least 8 characters long and include a number, lowercase, uppercase letters, and a special character."}.
                </div>
            )
        } else {
            return ''
        }
    } else if (type === enumUtil.enumValidationType.Email) {
        const Reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!Reg.test(data) && data && data.length > 0)
            return (
                <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                    <i className="bi bi-info-circle-fill fs-10"></i>
                    <p className="fs-9 text-white text">
                        {' '} {capitalize(name)} must be valid.
                    </p>
                </div>
            )
    } else if (type === enumUtil.enumValidationType.Website) {
        const urlPattern = /^(https?:\/\/)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(\S*)?$/
        if (!urlPattern.test(data) && data && data.length > 0) {
            return (
                <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                    <i className="bi bi-info-circle-fill fs-10"></i>
                    <p className="fs-9 text-white text">
                        {capitalize(name)} must be valid.
                    </p>
                </div>
            )
        }
    } else if (type === enumUtil.enumValidationType.Digit) {
        if (!isNull(data)) {
            let DigitValidation = /^\d+$/.test(data);
            if (DigitValidation === false) {
                return (
                    <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                        <i className="bi bi-info-circle-fill fs-10"></i>
                        <p className="fs-9 text-white text">
                            {capitalize(name)} must be numbers only
                        </p>
                    </div>
                )
            } else {
                return ''
            }
        } else {
            return ''
        }

    } else if (type === enumUtil.enumValidationType.Alphabet) {
        if (!isNull(data)) {
            let AlphabetValidation = /^[a-zA-Z]+$/.test(data);
            if (AlphabetValidation === false) {
                return (
                    <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                        <i className="bi bi-info-circle-fill fs-10"></i>
                        <p className="fs-9 text-white text">
                            {capitalize(name)} must be Alphabets only
                        </p>
                    </div>
                )
            } else {
                return ''
            }
        } else {
            return ''
        }
    } else if (type === 'Bool') {
        if (data == false || '') {
            return (
                <div className="invalid-feedback tool_tip flex items-center gap-1" style={{ display: "block" }}>
                    <i className="bi bi-info-circle-fill fs-10"></i>
                    <p className="fs-9 text-white text">{capitalize(name)} Is Required!</p>
                </div>
            )
        } else {
            return ''
        }
    }

    else {
        return ''
    }
}

// first letter of str to cap like name to Name
const capitalize = (params) => {
    if (typeof params === 'string') {
        return params.charAt(0).toUpperCase() + params.slice(1)
    }
    return null
}

// check if value is object 
const hasObject = (value) => {
    if (value instanceof Object) {
        return true
    } else {
        return false
    }
}
export default FormValidator